<template>
<div class="register2">

  <vue-headful
    title="Designbox - Company"
    description="Designbox"
/>


<section class="section register1">
    <div class="container">
    <div class="columns is-centered">
    <div class="column is-6">
    <h1 v-if="!generic">{{ $t("2-register") }}</h1>
    <h1 v-if="generic"><img v-show="site_logo" :src="site_logo" :alt="site_title" /><span v-show="! site_title_as_alt">{{ site_title }}</span></h1>
    <h2 v-if="generic">{{ $t("2-register") }}</h2>
    <p>{{ $t("2-register-details") }}</p><br>
    <form @submit.prevent="validateBeforeSubmit">
        <b-field grouped>
            <b-field :label="$t ('company-name')" expanded
                :type="{'is-danger': errors.has('name1')}"
                :message="errors.first('name1')">
                <b-input v-model="user.name1" name="name1" v-validate="'required'" />
            </b-field>

            <b-field :label="$t ('name2')" expanded
                :type="{'is-danger': errors.has('name2')}"
                :message="errors.first('name2')">
                <b-input v-model="user.name2" name="name2" />
            </b-field>
        </b-field>
        <b-field :label="$t ('address1')"
            :type="{'is-danger': errors.has('address1')}"
            :message="errors.first('address1')">
            <b-input type="text" v-model="user.address1" name="address1" v-validate="'required'" style="width:60%;" />
        </b-field>

        <b-field :label="$t ('address2')"
            :type="{'is-danger': errors.has('address2')}"
            :message="errors.first('address2')">
            <b-input type="text" v-model="user.address2" name="address2" style="width:60%;"/>
        </b-field>


        <b-field grouped>
            <b-field :label="$t ('zip')"
                :type="{'is-danger': errors.has('zip')}"
                :message="errors.first('zip')">
                <b-input type="text" v-model="user.zip" name="zip" v-validate="'required'" />
            </b-field>

            <b-field :label="$t ('city')" expanded
                :type="{'is-danger': errors.has('city')}"
                :message="errors.first('city')">
                <b-input type="text" v-model="user.city" name="city" v-validate="'required'" />
            </b-field>
        </b-field>

        <b-field :label="$t ('country')"
            :type="{'is-danger': errors.has('country')}"
            :message="errors.first('country')">
            <b-select :value="user.country" v-model="user.country" name="country" v-validate="'required'">
                            <option
                    v-for="country in getCountries"
                    :value="country[0]"
                    :key="country[0]">
                    {{ country[1] }}
                </option>
            </b-select>
        </b-field>


        <b-field grouped>
            <b-field :label="$t ('phone')" expanded
                :type="{'is-danger': errors.has('phone')}"
                :message="errors.first('phone')">
                <b-input type="text" v-model="user.phone" name="phone" v-validate="'required'" />
            </b-field>

            <b-field :label="$t ('mobilephone')" expanded
                :type="{'is-danger': errors.has('mobile')}"
                :message="errors.first('mobile')">
                <b-input type="text" v-model="user.mobile" name="mobile" />
            </b-field>
        </b-field>

        <b-field :label="$t ('email')"
            :type="{'is-danger': errors.has('email')}"
            :message="errors.first('email')">
            <b-input type="text" v-model="user.email" name="email" />
        </b-field>

        <b-field grouped>
            <b-field :label="$t ('uid-number')" expanded
                :type="{'is-danger': errors.has('vat_number')}"
                :message="errors.first('vat_number')">
                <b-input type="text" v-model="user.vat_number" name="vat_number" />
            </b-field>
            <b-field :label="$t ('customer-number')" expanded
                :type="{'is-danger': errors.has('customer_number')}"
                :message="errors.first('customer_number')">
                <b-input type="text" v-model="user.customer_number" name="customer_number" />
            </b-field>

            <b-field :label="$t ('company-type')" expanded
                :type="{'is-danger': errors.has('company_type')}"
                :message="errors.first('company_type')">
                <b-select v-model="user.company_type" name="company_type" >
                    <option value="X">{{ $t ("company_type-unspecified") }}</option>
                    <option value="C">{{ $t ("company_type-carpender") }}</option>
                    <option value="D">{{ $t ("company_type-dealer") }}</option>
                    <option value="I">{{ $t ("company_type-industry") }}</option>
                    <option value="E">{{ $t ("company_type-end-customer") }}</option>
                </b-select>
            </b-field>
        </b-field>

        <b-field grouped>
            <b-field label="" class="is-checkradio"
                :type="{'is-danger': errors.has('opt_out')}"
                :message="{'required' : errors.firstByRule('opt_out', 'required')}">
                <b-checkbox v-model="user.opt_out" name="opt_out">
                    {{ $t ("company-email-opt-out") }}
                </b-checkbox>
            </b-field>

            <b-field label="" class="is-checkradio"
                :type="{'is-danger': errors.has('user_opt_opt')}"
                :message="{'required' : errors.firstByRule('user_opt_opt', 'required')}">
                <b-checkbox v-model="user.user_opt_opt" name="user_opt_opt">
                    {{ $t ("user-email-opt-out") }}
                </b-checkbox>
            </b-field>
        </b-field>

        <button type="submit" class="button is-primary" v-if="!getRegisterActive"> {{ $t("finish-register") }} </button>
    </form>
    </div>
    </div>
    </div>
</section>
</div>
</template>

<script>
import { mapGetters } from 'vuex';
import config         from '@/config'

export default {
    name: 'RegisterCompany',
    props: ['token'],
    data: function(){
        return{
            user:{
            	token:'',
                name1:'',
                name2:'',
                address1:'',
                address2:'',
                zip:'',
                city:'',
                country:'',
                email:'',
                phone:'',
                mobile:'',
                vat_number:'',
                company_type:'',
                customer_number:'',
                opt_out:false,
                user_opt_opt:false
            },
            generic: config.generic,
            site_title: config.title,
            site_logo: config.logo,
            site_title_as_alt: config.title_as_alt,
        }
    },
    computed: {
        ...mapGetters(['getCountries',"getRegisterActive"]),
        location: {
            get () {
                return this.$route.params.location
            }
        }
    },
    methods: {
        validateBeforeSubmit() {
    	    this.user.token = this.token;
            var self= this;
            this.$validator.validateAll().then((result) => {
                if (result) {
                    this.$store.dispatch("registerCompany",{user:this.user,self:self})
                    return
                }
            });
        }
    },
    created() {
        var self = this;
        this.$store.dispatch("callCountries",{self:self});
    }
}
</script>

<style>

</style>